import PropTypes from 'prop-types';
import { Stack, Typography } from '@mui/material';
import DateFilter from 'components/FilterFields/DateFilter';

function AdvancedDateFilter(props) {
    return (
        <>
            <Stack spacing={2} mb={0.5}>
                <Typography variant="text1" gutterBottom>
                    {props.header || 'Date'}
                </Typography>
            </Stack>
            <Stack spacing={2} mb={1} sx={{ visibility: 'hidden' }}>
                <Typography variant="subtitle1" gutterBottom>
                    {props.helperText || 'Select Min and Max Date'}
                </Typography>
            </Stack>
            <DateFilter
                comparableType={props.comparableType}
                width="100%"
                label={props.label}
                attr={props.attr}
                displayRight={props.displayRight}
            />
        </>
    );
}

AdvancedDateFilter.propTypes = {
    comparableType: PropTypes.string,
    label: PropTypes.string,
    header: PropTypes.string,
    helperText: PropTypes.string,
    attr: PropTypes.string.isRequired,
    displayRight: PropTypes.bool,
};

export default AdvancedDateFilter;